import React, { Component, PropTypes } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import {
	NitroHeading,
	NitroParagraph,
	NitroButton,
	NitroIcon
} from "nitro-components";

import ChartSpiderWeb
	from "../../../../../components/charts/chart-bar/ChartSpiderWeb";
import styled from "styled-components";

import GenericError from "../../../../../features/errors/GenericError";

import { notify } from "../../../../../components/libs/notification";

const TelematicsChartView = styled.div`
	display: block;
`;

const Overlay = styled.div`
	background: ${props => props.theme.color.white};
	opacity: 0.3;
	position: absolute;
	width: 100%;
	height: 100%;
	top: 0px;
	left: 0px;
`;

const OverlayContent = styled.div`
	display: flex;
	align-items: center;
	position: absolute;
	top: 38%;
	left: 25%;
	width: 50%;

	flex-direction: column;

`;

const TelematicsInformation = styled.div`
	position: relative;
`;

const PlaceholderContent = styled.div`
	display: block;
`;

const LockContainer = styled.div`
	width: 40px;
	height: 40px;
	border-radius: 20px;
	background: ${props => props.theme.color.primary};
	text-align: center;
	padding: 6px;
`;

class DriverTelematicsChart extends Component {
	constructor(props) {
		super(props);
		this.state = {
			setMockData: false,
			mockData: {},
      telematicsInfo: {},
		};
	}

	componentWillMount() {
		this.setMockInformation();
	}

	componentDidMount() {
		this.setData();
        if (!this.props.telematicsAvailable) {
          this.timer = setInterval(this.setMockInformation, 3000);
          if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
          }
        }
	}

	componentDidUpdate(prevProps) {
		if (prevProps.driverId === this.props.driverId) {
			return;
		}

    if (this.props.telematicsAvailable) {
			this.setData();
		} else {
			this.setMockInformation();
			this.timer = setInterval(this.setMockInformation, 3000);
		}
	}

	componentWillUnmount() {
		if (this.timer) {
			clearInterval(this.timer);
			this.timer = null;
		}
	}

	setData = () => {
		const telematicsInfo = this.props.data;
    const telematicsAvailable = this.props.telematicsAvailable;
		const categories = telematicsInfo.map((item, i) => {
			return item.Title;
		});
		const data = telematicsInfo.map((item, i) => {
			return item.Value;
		});
		if (telematicsAvailable) {
			this.setState({
				telematicsInfo: {
					Categories: categories,
					Data: data
				}
			});
		} else {
			this.setState({
				telematicsInfo: {}
			});
		}
    };

    sendGetTelematicsEmail = () => {
      const filters =  {};
      this.props.sendGetTelematicsEmail(filters)
      this.props.notify({
        type: "success",
        title: "Telematics",
        message: "Thank you. We will get back to you shortly."
      });
    };

	setMockInformation = () => {
		const mockArray = [];
		for (let i = 0; i < 6; i++) {
			mockArray.push(Math.floor(Math.random() * 10 + 10));
		}
		this.setState({
			mockData: {
				Categories: [
					"Hard braking",
					"Hard Acceleration",
					"hard cornering",
					"Speeding",
					"Driving time exceeded",
					"Policy breahes"
				],
				Data: mockArray
			}
		});
	};

    render() {
    const { telematicsInfo } = this.state;

		return (
			<TelematicsChartView>
				<NitroHeading
					label="Driver Behaviour"
					size="3"
					align="center"
					header
					variant="base1"
					opacity="0.5"
				/>
         <TelematicsInformation>
              <ChartSpiderWeb data={telematicsInfo} />
              {!this.props.telematicsAvailable &&
						      <PlaceholderContent>
							      <Overlay>
								      <ChartSpiderWeb
									      data={this.state.mockData}
									      disableDataPoints
								      />
							      </Overlay>
							      <OverlayContent>
								      <LockContainer>
									      <NitroIcon
										      name="lock"
										      size={18}
										      variant="white"
									      />
								      </LockContainer>
								      <NitroParagraph
									      align="center"
									      bold
									      variant="base1"
								      >
									      Want more detailed and accurate
									      driver behaviour data for your fleet?
								      </NitroParagraph>
								      <NitroButton
                          label="Enquire about Telematics"
                          variant="primary"
                          size="small"
                          action={this.sendGetTelematicsEmail}
                  />

                </OverlayContent>

                </PlaceholderContent>}

            </TelematicsInformation>
			</TelematicsChartView>
		);
	}
}

DriverTelematicsChart.propTypes = {
  driverId: PropTypes.string,
  driverName: PropTypes.string,
	data: PropTypes.array.isRequired,
  telematicsAvailable: PropTypes.bool,
  sendGetTelematicsEmail: PropTypes.func,
  get: PropTypes.func,
  select: PropTypes.func,
  onChange: PropTypes.func,
  save: PropTypes.func,
  notify: PropTypes.func,
	error: PropTypes.bool // TODO .isRequired
};

const mapDispatchToProps = dispatch => ({
  notify: bindActionCreators(notify, dispatch)
});

export default connect(null, mapDispatchToProps) (DriverTelematicsChart);



// WEBPACK FOOTER //
// ./src/features/insights/components/driverSafety/components/DriverTelematicsChart.js